/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_All_RolesInputs */

const vi_user_all_roles = /** @type {(inputs: User_All_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả vai trò`)
};

/**

* @param {User_All_RolesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const user_all_roles = /** @type {((inputs?: User_All_RolesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_All_RolesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_user_all_roles(inputs)
});